import { Megaphone, Check } from "lucide-react";
import { UPDATES } from "@/data/updates";

const fmtDate = (d) =>
  new Date(d + "T00:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" });

export default function WhatsNew() {
  return (
    <div className="max-w-3xl mx-auto px-6 sm:px-8 pt-12 sm:pt-16 pb-24" data-testid="whats-new-page">
      <div className="flex items-center gap-3 mb-2">
        <Megaphone className="w-6 h-6 text-[#2C2A29]" strokeWidth={1.5} />
        <p className="font-body text-sm uppercase tracking-[0.2em] text-[#7A756E]">What's New</p>
      </div>
      <h1 className="font-heading text-3xl sm:text-4xl text-[#2C2A29] tracking-tight">Latest updates</h1>
      <p className="font-decree text-lg text-[#7A756E] mt-3">
        Everything we've been building for It Is Established — newest first.
      </p>

      <ol className="mt-12 space-y-12 border-l border-[#D9D4CC] pl-6 sm:pl-8">
        {UPDATES.map((u) => (
          <li key={u.date} data-testid={`update-${u.date}`} className="relative animate-fade-up">
            <span className="absolute -left-[33px] sm:-left-[41px] top-1.5 w-3.5 h-3.5 rounded-full bg-[#9B7E4E] ring-4 ring-[#FAF9F6]" />
            <p className="font-body text-xs uppercase tracking-[0.2em] text-[#9B7E4E]">{fmtDate(u.date)}</p>
            <h2 className="font-heading text-2xl text-[#2C2A29] tracking-tight mt-1">{u.version}</h2>
            <ul className="mt-4 space-y-2.5">
              {u.items.map((it, i) => (
                <li key={i} className="flex gap-2.5 font-body text-base text-[#4A4744] leading-relaxed">
                  <Check className="w-4 h-4 text-[#9B7E4E] shrink-0 mt-1" strokeWidth={2} />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
}
